import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/Download';
import Moment from 'moment';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_ProduceWorkDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const fromSearch = location.state?.fromSearch || {};
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [data, setData] = useState(null);
    const [itemRows, setItemRows] = useState([]);
    const [itemColumns, setItemColumns] = useState([]);
    const [lotRows, setLotRows] = useState([]);
    const [lotColumns, setLotColumns] = useState([]);
    const [createlotRows, setCreateLotRows] = useState([]);
    const [createlotColumns, setCreateLotColumns] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [userColumns, setUserColumns] = useState([]);
    const [fileRows, setFileRows] = useState([]);
    const [fileColumns, setFileColumns] = useState([]);

    useEffect(() => {
        // 권한 설정은 주석 처리된 상태
        if(params.produce_work_id === null || typeof params.produce_work_id === 'undefined'){
            navigate("/m/produce_work", { state: { fromSearch } });
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);
    
    useEffect(() => {
        setItemColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'produce_work_item_name', headerName: '품목', width: 170, headerAlign: 'center', align:'left' },
            { field: 'produce_work_item_spec', headerName: '규격', width: 250, headerAlign: 'center', align:'left' },
            { field: 'produce_work_item_count', headerName: '출하수량', type: 'number', width: 100, headerAlign: 'center', align:'right' },
            /*{ field: 'outgoing_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 100, headerAlign: 'center', align:'center' },*/
            { field: 'produce_work_item_bigo', headerName: '비고', width: 250, headerAlign: 'center', align:'left' },
        ]);

        setUserColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'produce_work_user_name', headerName: '담당자명', width: 150, headerAlign: 'center', align:'center' },
            { field: 'produce_work_user_dept_name', headerName: '담당자부서', width: 150, headerAlign: 'center', align:'center' },
            { field: 'produce_work_user_position_name', headerName: '담당자직위', width: 150, headerAlign: 'center', align:'center' },
            { field: 'produce_work_user_type_name', headerName: '담당자유형', type: 'text', width: 150, headerAlign: 'center', align:'center' },
            { field: 'produce_work_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left' }
        ]);

        setLotColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
            { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
            { field: 'lot_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
            { field: 'lot_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
            /*{ field: 'lot_produce_work_quality_exam_yn', headerName: '검사여부', type: 'text', width: 80, headerAlign: 'center', align:'center' },*/
            { field: 'lot_produce_work_save_workplace_name', headerName: '사업장',width: 135, headerAlign: 'center'},
            { field: 'lot_produce_work_save_warehouse_name', headerName: '창고', width: 135, headerAlign: 'center', align:'left' },
            { field: 'lot_produce_work_save_section_name', headerName: '구역',width: 135, headerAlign: 'center', align:'left'}
        ]);

        setCreateLotColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
            { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
            { field: 'lot_create_produce_work_item_name', headerName: '품목', width: 130, headerAlign: 'center', align:'left' },
            { field: 'lot_create_produce_work_item_spec', headerName: '규격', width: 185, headerAlign: 'center', align:'left' },
            /*{ field: 'lot_create_produce_work_quality_exam_yn', headerName: '검사여부', type: 'text', width: 80, headerAlign: 'center', align:'center' },*/
            { field: 'lot_create_produce_work_save_workplace_name', headerName: '사업장',width: 135, headerAlign: 'center'},
            { field: 'lot_create_produce_work_save_warehouse_name', headerName: '창고', width: 135, headerAlign: 'center', align:'left' },
            { field: 'lot_create_produce_work_save_section_name', headerName: '구역',width: 135, headerAlign: 'center', align:'left'}
        ]);

        setFileColumns([
            {
                field: 'download',
                headerName: '다운로드',
                width: 100,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
            { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
            { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
            { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
            { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
            { field: 'file_type_name', headerName: '유형', width: 120, headerAlign: 'center', align:'center' },
            { field: 'file_size_dp', headerName: '크기', width: 120, headerAlign: 'center', align:'right' },
            { field: 'reg_user_name', headerName: '등록자', width: 120, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 180, headerAlign: 'center', align:'center' },
        ]);
        
        if(String(MenuID) !== String(0) && typeof fromSearch.originRows === 'undefined'){
            handleSearch();
        }else{
            setOriginRows(fromSearch.originRows);
        }
    }, [MenuID]);

    useEffect(() => {
        if(typeof originRows !== 'undefined'){
            if(originRows.length > 0){
                setData(
                    {
                        produce_work_id: originRows[0].produce_work_id,
                        produce_work_number: originRows[0].produce_work_number,
                        produce_work_bom_id: originRows[0].produce_work_bom_id,
                        produce_work_bom_name: originRows[0].produce_work_bom_name,
                        produce_work_item_id: originRows[0].produce_work_item_id,
                        produce_work_item_name: originRows[0].produce_work_item_name,
                        produce_work_item_type_name: originRows[0].item_type_name,
                        produce_work_item_division_name: originRows[0].item_division_name,
                        produce_work_item_spec: originRows[0].produce_work_item_spec,
                        produce_work_start_datetime: originRows[0].produce_work_start_datetime === undefined? '':Moment(originRows[0].produce_work_start_datetime).format('YYYY-MM-DD HH:mm:ss'),
                        produce_work_end_datetime: originRows[0].produce_work_end_datetime === undefined?'':Moment(originRows[0].produce_work_end_datetime).format('YYYY-MM-DD HH:mm:ss'),
                        produce_work_count: originRows[0].produce_work_count,
                        produce_work_complete_count: originRows[0].produce_work_complete_count,
                        produce_work_error_count: originRows[0].produce_work_error_count,
                        produce_work_bigo: originRows[0].produce_work_bigo
                    }
                )

                var itemData = originRows.filter((item, index) => {
                    return (
                        originRows.findIndex((item2, index2) => {
                        return typeof item.produce_work_input_item_seq !== 'undefined' && item.produce_work_input_item_seq === item2.produce_work_input_item_seq;
                        }) === index
                    );
                });

                setItemRows(itemData.map((item, index) => ({
                    id: item.produce_work_input_item_seq,
                    produce_work_item_name: item.produce_work_input_item_name,
                    produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.produce_work_input_item_spec, item.produce_work_input_item_width, item.produce_work_input_item_height, item.produce_work_input_item_depth),
                    produce_work_item_count: item.produce_work_input_item_count,
                    produce_work_quality_exam_yn: 'N',
                    produce_work_item_bigo: item.produce_work_input_item_bigo,
                })));
                
                
                var userData = originRows.filter((item, index) => {
                return (
                    originRows.findIndex((item2, index2) => {
                    return typeof item.produce_work_user_seq !== 'undefined' && item.produce_work_user_seq === item2.produce_work_user_seq;
                    }) === index
                );
                });

                setUserRows(userData.map((item, index) => ({
                    id: item.produce_work_user_seq,
                    produce_work_user_name: item.produce_work_user_name,
                    produce_work_user_dept_name: item.produce_work_user_dept_name,
                    produce_work_user_position_name: item.produce_work_user_position_name,
                    produce_work_user_type: item.produce_work_user_type,
                    produce_work_user_bigo: item.produce_work_user_bigo,
                })));

                var fileData = originRows.filter((item, index) => {
                return (
                    originRows.findIndex((item2, index2) => {
                    return typeof item.produce_work_file_id !== 'undefined' && item.produce_work_file_id === item2.produce_work_file_id;
                    }) === index
                );
                });

                setFileRows(fileData.map((item, index) => ({
                    id: item.produce_work_file_id,
                    file_name_sever: item.produce_work_file_name_sever,
                    file_size: item.produce_work_file_size,
                    file_type: item.produce_work_file_type,
                    file_extension: item.produce_work_file_extension,
                    file_name: item.produce_work_file_name,
                    file_type_name: item.produce_work_file_type_name,
                    file_size_dp: item.produce_work_file_size_dp,
                    reg_user_name: item.produce_work_file_user_name,
                    reg_datetime: Moment(item.produce_work_file_user_datetime).format('YYYY-MM-DD HH:mm:ss')
                })));
                
                axios.get('/api/p/ProduceWork/CreateItemLotList',
                    {
                    params : {
                        produce_work_id : params.produce_work_id
                    }
                },
                { withCredentials: true }
                )
                .then((response) => {
                if(response.data.length > 0){

                    var createLotData = (response.data).filter((item, index) => {
                    return (
                        (response.data).findIndex((item2, index2) => {
                        return typeof item.lot_produce_work_item_lot_seq !== 'undefined' && item.lot_produce_work_item_lot_seq === item2.lot_produce_work_item_lot_seq;
                        }) === index
                    );
                    });

                    setCreateLotRows(createLotData.map((item, index) => ({
                        id: item.lot_produce_work_item_lot_seq,
                        lot_no: item.lot_produce_work_item_lotno,
                        lot_create_produce_work_item_name: item.lot_produce_work_item_name,
                        lot_create_produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_produce_work_item_spec, item.lot_produce_work_item_width, item.lot_produce_work_item_height, item.lot_produce_work_item_depth),
                        lot_create_produce_work_quality_exam_yn: item.produce_work_quality_exam_yn,
                        lot_create_produce_work_save_workplace_name: item.lot_produce_work_save_workplace_name,
                        lot_create_produce_work_save_warehouse_name: item.lot_produce_work_save_warehouse_name,
                        lot_create_produce_work_save_section_name: item.lot_produce_work_save_section_name
                    })));
                }

                axios.get('/api/p/ProduceWork/UseItemLotList',
                    {
                    params : {
                        produce_work_id : params.produce_work_id
                    }
                    },
                    { withCredentials: true }
                )
                .then((response) => {
                    if(response.data.length > 0){
                    var useLotData = (response.data).filter((item, index) => {
                        return (
                        (response.data).findIndex((item2, index2) => {
                            return typeof item.lot_produce_work_use_item_lot_seq !== 'undefined' && item.lot_produce_work_use_item_lot_seq === item2.lot_produce_work_use_item_lot_seq;
                        }) === index
                        );
                    });

                    setLotRows(useLotData.map((item, index) => ({
                        id: item.lot_produce_work_use_item_lot_seq,
                        lot_no: item.lot_produce_work_use_item_lotno,
                        lot_produce_work_item_name: item.lot_produce_work_use_item_name,
                        lot_produce_work_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.lot_produce_work_use_item_spec, item.lot_produce_work_use_item_width, item.lot_produce_work_use_item_height, item.lot_produce_work_use_item_depth),
                        lot_produce_work_quality_exam_yn: item.produce_work_use_quality_exam_yn,
                        lot_produce_work_save_workplace_name: item.lot_produce_work_use_save_workplace_name,
                        lot_produce_work_save_warehouse_name: item.lot_produce_work_use_save_warehouse_name,
                        lot_produce_work_save_section_name: item.lot_produce_work_use_save_section_name
                    })));
                    
                    }
                })
                .catch((error) => {
                    appStore.capture();
                });
                })
                .catch((error) => {
                    appStore.capture();
                });
            }
        }
    }, [originRows]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/ProduceWork/List',
            {
                params: {
                    produce_work_id: params.produce_work_id
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setOriginRows(response.data);
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const fileDownloadClick = (object) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
                    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

        if (isIOS) {
            // iOS는 XHR+blob 대신, 폼 POST로 새 탭 열어 서버가 직접 다운로드 처리
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/SaveCommon/FileDownload';
            form.target = '_blank'; // 새 탭 (팝업 차단 회피용: 클릭 안에서 즉시 submit)

            const add = (n, v) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = n;
                input.value = v ?? '';
                form.appendChild(input);
            };
            add('fileName', object.row.file_name);
            add('fileNameSever', object.row.file_name_sever);
            document.body.appendChild(form);
            form.submit();
            form.remove();
            return;
        }

        // 나머지(PC/안드): 기존 axios + blob
        axios.post(
            '/api/SaveCommon/FileDownload',
            new URLSearchParams({
                fileName: object.row.file_name,
                fileNameSever: object.row.file_name_sever
            }),
            { withCredentials: true, responseType: 'blob' }
        ).then((res) => {
            if (res.status !== 200) return appStore.capture();
            const type = res.headers?.['content-type'] || 'application/octet-stream';
            const blob = new Blob([res.data], { type });
            const url  = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = object.row.file_name || 'download.bin';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        }).catch((e) => {
            appStore.capture();
            console.log('다운로드 실패', e);
        });
    };

    const handleList = () => {
        navigate("/m/produce_work", { state: { fromSearch } });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleList}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white", 
                                borderColor: "black", 
                                backgroundColor: "black",
                                ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                            }}
                            variant="outlined">
                            목록
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    {/* 출하 기본 정보 */}
                    {data ? (
                        <>
                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 정보</h2>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>생산작업번호</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.produce_work_number || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>BOM정보</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.produce_work_bom_name || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>품목정보</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.produce_work_item_name + ' ' + data.produce_work_item_spec || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>생산시작일시</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.produce_work_start_datetime || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>생산종료일시</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>{data.produce_work_end_datetime || '-'}</div>
                            </div>

                            <div style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>작업수량 / 정품수량 / 불량수량</div>
                            <div style={{ fontSize: '16px', color: '#333', marginTop: '4px' }}>
                                {data.produce_work_count + ' / ' + data.produce_work_complete_count + ' / ' + data.produce_work_error_count}
                            </div>
                            </div>

                            <div style={{ padding: '8px 0' }}>
                            <div style={{ fontSize: '18px', fontWeight: '600', color: '#444' }}>비고</div>
                            <div 
                                style={{ 
                                fontSize: '16px', 
                                color: '#333', 
                                marginTop: '4px',
                                whiteSpace: 'pre-wrap', // 줄바꿈 유지
                                lineHeight: '1.5'       // 가독성 좋게 줄 간격 추가
                                }}
                            >
                                {(data.produce_work_bigo && data.produce_work_bigo.trim() !== '') 
                                ? data.produce_work_bigo 
                                : '-'}
                            </div>
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 품목</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={itemRows}
                                    columns={itemColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, outgoing_item_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 사용Lot</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={lotRows}
                                    columns={lotColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, upper_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 생산Lot</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={createlotRows}
                                    columns={createlotColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, upper_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 담당자</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={userRows}
                                    columns={userColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, outgoing_user_id: false}}              
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: '#fdfdfd',
                            marginTop: '10px',
                            borderRadius: '12px',
                            padding: '10px',
                            marginBottom: '24px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                            border: '1px solid #eee'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '24px', marginRight: '8px' }}>ℹ️</span>
                            <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#222', margin: 0 }}>생산작업 파일</h2>
                            </div>

                            <div style={{ padding: '0px', height: '300px' }}>
                                <DataGrid
                                    rows={fileRows}
                                    columns={fileColumns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    initialState={{ 
                                        density: 'compact',
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                    columnVisibilityModel={{id: false, file_name_sever: false, file_size: false, file_type : false, file_extension: false, download: false}}
                                    sx={{
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontSize: '15px',
                                        fontWeight: 'bold'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    ) : (
                        <p style={{ textAlign: "center", color: "#999" }}>생산작업 데이터를 불러오는 중입니다...</p>
                    )}
                    </div>

            </div>
        </div>
    );
};

export default MOB_ProduceWorkDetail;